export default __webpack_public_path__ + "static/media/maptyProject.ab375979.jpg";